








































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import SubjectCorVue from "./SubjectCor.vue";
import AccountingSystem from "@/data/AccountingSystem";

@Component({
    components: {
        "subject-cor": SubjectCorVue,
    }
})
export default class AccountBookImport extends Vue {
    options = AccountingSystem;
    value: string = AccountingSystem.thirteenRule;
    filename: string = "";
    bookName: string = "";
    bookCode: string = "";
    showSubjectCor: boolean = false;
    buttonActive: boolean = false;
    finishButton: boolean = false;
    fileMessage: any = {
        startPeriod: "",
        subjectNum: "",
        subjectQcNum: "",
        voucherNum: "",
        voucherRecordNum: "",
        assistant: "",
        accountingSystem: "",
        key: ""
    };

    isUpload: boolean = false; //正在上传的状态

    getFileName(el: any) {
        this.buttonActive = false;
        let filename = el.currentTarget.files[0].name;
        let postfixname = filename.substring(filename.length - 3, filename.length);
        let elInput: HTMLElement = <HTMLElement>document.querySelector("#fileInput .fileName");
        if (postfixname != "zip") {
            this.$message.warning(filename + "是不允许上传的文件类型");
            // @ts-ignore
            elInput.innerHTML = "";
        } else {
            // @ts-ignore
            elInput.innerHTML = filename;
            if (filename.indexOf("-20") != "-1") {
                this.bookName = filename.substring(0, filename.indexOf("-20"));
            } else {
                this.bookName = filename.replace(".zip", "")
            }

        }
    }
    fnUpload() {
        if (this.bookName != "" && this.bookCode != "") {
            let elInput: HTMLElement = <HTMLElement>document.querySelector("#fileInput .fileName")
            if (elInput.innerHTML == "") {
                this.$message.warning("请选择文件");
                return;
            }
            let elUp: any = document.querySelector("#up");
            let data = new FormData(elUp);
            Vue.axios
                .post(`import/upload`, data)
                .then(res => {
                    this.$msgbox.alert(res.data.message);
                    if (res.data.subjectNum == 0) {
                        this.finishButton = true;
                    } else {
                        this.finishButton = false;
                    }
                    this.buttonActive = true;
                    Object.keys(this.fileMessage).forEach(key => {
                        this.fileMessage[key] = res.data[key]
                    });
                });
        }
    }
    showSubCor() {
        if (this.buttonActive) {
            this.showSubjectCor = true;
        }
    }
    matchSuccess() {
        let subjectCor: any = this.$refs.subjectCor;
        if (subjectCor.unMatchSubjectList.length == 0) {
            this.finishButton = true;
        } else {
            this.$alert("亲，您还有科目没有匹配完成！");
            this.finishButton = false;
        }
    }
    importAccount() {
        if (this.finishButton) {
            this.isUpload = true;
            Vue.axios
                .post(`import/bookData?key=${this.fileMessage.key}&accounterId=${this.$store.state.account.id}`, {})
                .then(res => {
                    setTimeout(() => {
                        this.isUpload = false;
                        this.$msgbox.alert("成功导入 " + this.bookName + "！", {});
                    }, 888)
                }).catch(res => {
                    setTimeout(() => {
                        this.isUpload = false;
                        this.$message.warning("亲，导入失败，请稍后重试。");
                    }, 888)
                });
        }
    }
}
